import { render, staticRenderFns } from "./CoordinationConversionConfirmTable.vue?vue&type=template&id=99414c20&scoped=true"
import script from "./CoordinationConversionConfirmTable.vue?vue&type=script&lang=ts"
export * from "./CoordinationConversionConfirmTable.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationConversionConfirmTable.vue?vue&type=style&index=0&id=99414c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99414c20",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/coordination/conversion/coordination-conversion-confirm-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fcoordination%2Fconversion%2FCoordinationConversionConfirmTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports